import { Action } from 'contexts/useReducerWithMiddleware';
import { OrganizationMember } from 'types';
import { Invite } from 'types/Invite';
import {
    DELETE_INVITE_FAILED,
    DELETE_INVITE_REQUESTED,
    DELETE_INVITE_SUCCESS,
    DELETE_ORGANIZATION_MEMBER_FAILED,
    DELETE_ORGANIZATION_MEMBER_REQUESTED,
    DELETE_ORGANIZATION_MEMBER_SUCCESS,
    SEND_INVITE_FAILED,
    SEND_INVITE_REQUESTED,
    SEND_INVITE_SUCCESS,
    TEAM_FAILED,
    TEAM_REQUESTED,
    TEAM_SUCCESS,
} from './constants';

export type Team = {
    invites: Invite[];
    organizationMembers: OrganizationMember[];
};

export type TeamState = {
    team: Team | null;
    errorMessage: string;
    loading: boolean;
    successMessage: string;
};

export const initialTeamState: TeamState = {
    team: null,
    errorMessage: '',
    loading: false,
    successMessage: '',
};

export default function visitorCodesReducer(state: TeamState = initialTeamState, action: Action): TeamState {
    switch (action.type) {
        case TEAM_REQUESTED:
            return {
                ...state,
                loading: true,
                errorMessage: '',
                // Don't clear success message on team request since we immediately re-request the team after
                // other operations
            };
        case TEAM_SUCCESS:
            return {
                ...state,
                loading: false,
                errorMessage: '',
                team: (action.payload as { team: Team }).team,
            };
        case SEND_INVITE_REQUESTED:
        case DELETE_INVITE_REQUESTED:
        case DELETE_ORGANIZATION_MEMBER_REQUESTED:
            return {
                ...state,
                loading: true,
                errorMessage: '',
                successMessage: '',
            };
        case TEAM_FAILED:
        case SEND_INVITE_FAILED:
        case DELETE_INVITE_FAILED:
        case DELETE_ORGANIZATION_MEMBER_FAILED:
            return {
                ...state,
                loading: false,
                errorMessage: (action.payload as { message: string }).message,
            };
        case SEND_INVITE_SUCCESS:
            return {
                ...state,
                errorMessage: '',
                successMessage: 'Team member invited via email.',
            };
        case DELETE_INVITE_SUCCESS:
        case DELETE_ORGANIZATION_MEMBER_SUCCESS:
            return {
                ...state,
                errorMessage: '',
                successMessage: 'Team member removed.',
            };
        default:
            return state || initialTeamState;
    }
}
